/**
 * Processes trade-in value updates
 * @param {string} key - The parameter key being updated
 * @param {*} value - The new value
 * @param tradeIn
 * @returns {Object} Updated trade-in object
 */
const getTradeInUpdates = (key, value, tradeIn) => {
  if (key === 'tradeInInput') {
    return {
      source: 'USER',
      amountOwed: tradeIn.amountOwed,
      value
    };
  }
  if (key === 'amountOwedInput') {
    return {
      ...tradeIn,
      amountOwed: value
    };
  }
  return {};
};
export { getTradeInUpdates as default };
